<template>
  <div>
    <v-container class="kpr-container">
      <v-form ref="generateReportForm" @submit.prevent="submit">

        <div class="kpr-card" v-if="showForm">

          <!-- I. Opći podaci -->
          <div class="kpr-section-title">I. Opći podaci o poreznom obvezniku</div>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-text-field label="OIB" v-model="oib" outlined dense hide-details class="kpr-field" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field label="Ime i prezime" v-model="firstLast" outlined dense hide-details class="kpr-field" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field label="Adresa prebivališta / uobičajenog boravišta" v-model="adresaPrebivalista" outlined dense hide-details class="kpr-field" />
            </v-col>
          </v-row>

          <!-- II. Podaci o djelatnosti -->
          <div class="kpr-section-title">II. Podaci o djelatnosti</div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field label="Naziv i vrsta djelatnosti" v-model="nazivVrstaDjelatnosti" outlined dense hide-details class="kpr-field" />
            </v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12">
              <v-text-field label="Adresa obavljanja djelatnosti" v-model="adresaDjelatnosti" outlined dense hide-details class="kpr-field" />
            </v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12">
              <div class="posd-radio-label">Grad Vukovar i potpomognuta područja JLS I. skupine i otoci I. skupine</div>
              <v-radio-group v-model="vuIslands" row class="mt-1">
                <v-radio v-for="radio in radios" :key="radio.value" :value="radio.value" :label="radio.name" color="#00BCD4" />
              </v-radio-group>
            </v-col>
          </v-row>

          <!-- Razdoblje -->
          <div class="kpr-section-title">Razdoblje obavljanja djelatnosti</div>
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-menu v-model="fromMenu1" offset-y :close-on-content-click="false" transition="scale-transition" max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="formatFrom1" label="Od datuma (1)" outlined dense hide-details prepend-inner-icon="mdi-calendar" readonly class="kpr-field" v-bind="attrs" v-on="on" />
                </template>
                <v-date-picker v-model="from1" no-title scrollable min="2024-01-01" @change="changeMonths()" :max="maxTo1()" locale="hr-HR" @input="fromMenu1 = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <v-menu v-model="toMenu1" offset-y :close-on-content-click="false" transition="scale-transition" max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="formatTo1" label="Do datuma (1)" outlined dense hide-details prepend-inner-icon="mdi-calendar" readonly class="kpr-field" v-bind="attrs" v-on="on" />
                </template>
                <v-date-picker v-model="to1" locale="hr-HR" max="2030-12-31" no-title scrollable @change="changeMonths()" @input="toMenu1 = false" />
              </v-menu>
            </v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" sm="6">
              <v-menu v-model="fromMenu2" offset-y :close-on-content-click="false" transition="scale-transition" max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="formatFrom2" label="Od datuma (2)" outlined dense hide-details prepend-inner-icon="mdi-calendar" clearable @click:clear="clearFrom2()" class="kpr-field" v-bind="attrs" v-on="on" />
                </template>
                <v-date-picker v-model="from2" no-title scrollable :max="maxTo2()" :min="minto1()" @change="changeMonths()" locale="hr-HR" @input="fromMenu2 = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <v-menu v-model="toMenu2" offset-y :close-on-content-click="false" transition="scale-transition" max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="formatTo2" label="Do datuma (2)" outlined dense hide-details prepend-inner-icon="mdi-calendar" readonly clearable @click:clear="clearTo2()" class="kpr-field" v-bind="attrs" v-on="on" />
                </template>
                <v-date-picker v-model="to2" locale="hr-HR" :min="from2" max="2030-12-31" no-title scrollable @change="changeMonths()" @input="toMenu2 = false" />
              </v-menu>
            </v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" sm="6">
              <v-menu v-model="fromMenu3" offset-y :close-on-content-click="false" transition="scale-transition" max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="formatFrom3" label="Od datuma (3)" outlined dense hide-details prepend-inner-icon="mdi-calendar" readonly clearable @click:clear="clearFrom3()" class="kpr-field" v-bind="attrs" v-on="on" />
                </template>
                <v-date-picker v-model="from3" no-title scrollable :max="maxTo3()" :min="minto2()" @change="changeMonths()" locale="hr-HR" @input="fromMenu3 = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <v-menu v-model="toMenu3" offset-y :close-on-content-click="false" transition="scale-transition" max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="formatTo3" label="Do datuma (3)" outlined dense hide-details prepend-inner-icon="mdi-calendar" readonly clearable @click:clear="clearTo3()" class="kpr-field" v-bind="attrs" v-on="on" />
                </template>
                <v-date-picker v-model="to3" locale="hr-HR" no-title :min="from2" max="2030-12-31" scrollable @change="changeMonths()" @input="toMenu3 = false" />
              </v-menu>
            </v-col>
          </v-row>

          <!-- III. Primici -->
          <div class="kpr-section-title">III. Podaci o ostvarenim primicima od pojedinačne djelatnosti</div>
          <v-row dense>
            <v-col cols="12" sm="4">
              <money-input label="Primici naplaćeni u gotovini" v-model="primiciGotovina" :currency="currency" ref="primiciGotovina" @change="promjenaPrimitaka()" outlined dense hide-details class="kpr-field" />
            </v-col>
            <v-col cols="12" sm="4">
              <money-input label="Primici naplaćeni bezgotovinskim putem" v-model="primiciBezgotovinski" :currency="currency" ref="primiciBezgotovinski" @change="promjenaPrimitaka()" outlined dense hide-details class="kpr-field" />
            </v-col>
            <v-col cols="12" sm="4">
              <money-input label="Ukupno naplaćeni primici" v-model="ukupniPrimici" :currency="currency" ref="ukupniPrimici" outlined disabled dense hide-details class="kpr-field kpr-field-disabled" />
            </v-col>
          </v-row>

          <!-- IV. Dohodak samostalni -->
          <div class="kpr-section-title">IV. Godišnji paušalni dohodak od pojedinačne djelatnosti / Broj mjeseci</div>
          <v-row dense>
            <v-col cols="12" sm="6">
              <money-input label="Dohodak" v-model="dohodakSamostalni" :currency="currency" ref="dohodakSamostalni" outlined disabled dense hide-details class="kpr-field kpr-field-disabled" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field label="Broj mjeseci" v-model="mjeseciSamostalni" ref="mjeseciSamostalni" outlined suffix="mj." dense hide-details class="kpr-field" />
            </v-col>
          </v-row>

          <!-- V. Dohodak zajednički -->
          <div class="kpr-section-title">V. Godišnji paušalni dohodak od zajedničke djelatnosti / Broj mjeseci</div>
          <v-row dense>
            <v-col cols="12" sm="6">
              <money-input label="Dohodak zajednički" v-model="dohodakZajednicki" :currency="currency" ref="dohodakZajednicki" @change="promjenaZajednickogDohotka" outlined dense hide-details class="kpr-field" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field label="Broj mjeseci" v-model="mjeseciZajednicki" suffix="mj." outlined dense hide-details class="kpr-field" />
            </v-col>
          </v-row>

          <!-- VI. Ukupni dohodak -->
          <div class="kpr-section-title">VI. Ukupni godišnji paušalni dohodak</div>
          <v-row dense>
            <v-col cols="12" sm="6" offset-sm="6">
              <money-input label="Ukupni dohodak" v-model="ukupniDohodak" :currency="currency" ref="ukupniDohodak" outlined disabled dense hide-details class="kpr-field kpr-field-disabled" />
            </v-col>
          </v-row>

          <!-- VII. Obračun poreza -->
          <div class="kpr-section-title">VII. Obračun paušalnog poreza na dohodak</div>
          <v-row dense>
            <v-col cols="12" sm="6">
              <money-input label="1. Porez na dohodak (12%)" v-model="porezNaDohodak" :currency="currency" ref="porezNaDohodak" outlined disabled dense hide-details class="kpr-field kpr-field-disabled" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field label="2. Prirez porezu na dohodak (%)" v-model="prirezPostotak" outlined dense hide-details class="kpr-field" suffix="%" />
            </v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" sm="6">
              <money-input label="3. Prirez porezu na dohodak (iznos)" v-model="prirezIznos" :currency="currency" outlined disabled dense hide-details class="kpr-field kpr-field-disabled" />
            </v-col>
            <v-col cols="12" sm="6">
              <money-input label="4. Ukupno porez i prirez" v-model="ukupniPorezPrirez" :currency="currency" ref="ukupniPorezPrirez" @change="ukupniPorezPrirezPromjena" outlined dense hide-details class="kpr-field" />
            </v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" sm="6">
              <money-input label="5. Umanjenje za Vukovar/otoke" v-model="umanjenjePoreza" :currency="currency" ref="umanjenjePoreza" @change="umanjenjePorezaPromjena" outlined dense hide-details class="kpr-field" />
            </v-col>
            <v-col cols="12" sm="6">
              <money-input label="6. Ukupno porez i prirez nakon umanjenja" v-model="ukupniPorezPrirezNakonUmanjenja" :currency="currency" ref="ukupniPorezPrirezNakonUmanjenja" outlined disabled dense hide-details class="kpr-field kpr-field-disabled" />
            </v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" sm="6">
              <money-input label="7. Već uplaćeni porez i prirez" v-model="uplaceniPorezPrirez" :currency="currency" ref="uplaceniPorezPrirez" @change="promjenaPlacenog" outlined dense hide-details class="kpr-field" />
            </v-col>
            <v-col cols="12" sm="6">
              <money-input label="8. Razlika za uplatu / povrat" v-model="razlikaUplataPovrat" :currency="currency" ref="razlikaUplataPovrat" outlined disabled dense hide-details class="kpr-field kpr-field-disabled" />
            </v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" sm="6" offset-sm="6">
              <money-input label="9. Porez i prirez po mjesecu" v-model="porezPrirezMjesecni" :currency="currency" ref="porezPrirezMjesecni" outlined disabled dense hide-details class="kpr-field kpr-field-disabled" />
            </v-col>
          </v-row>

          <!-- Actions -->
          <div class="kpr-actions">
            <v-btn class="kpr-generate-btn mr-3" :disabled="submitting" :loading="submitting && docType.value === 'pdf'" @click="submit('pdf')" elevation="0">
              <v-icon left small>mdi-file-pdf-box</v-icon>
              Generiraj PDF
            </v-btn>
            <v-btn class="kpr-generate-btn kpr-generate-btn--excel" :disabled="submitting" :loading="submitting && docType.value === 'xlsx'" @click="submit('xlsx')" elevation="0">
              <v-icon left small>mdi-file-excel-box</v-icon>
              Generiraj Excel
            </v-btn>
          </div>

        </div>

      </v-form>

      <v-overlay v-show="loading" absolute z-index="10">
        <v-progress-circular indeterminate size="64" color="primary" />
      </v-overlay>
    </v-container>
  </div>
</template>
<script>
import applicationSettings from '@/mixins/applicationSettings'
import { df, functions } from '@/plugins/firebase'
import state from '@/state'
import rules from '@/plugins/rules'
import MoneyInput from '@/components/MoneyInput'

export default {
  name: 'Reports',
  mixins: [applicationSettings],
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  components: { MoneyInput },
  data: function () {
    return {
      visible: false,
      lastVisible: '',
      submitting: false,
      loading: false,
      companies: [],
      company: undefined,
      oib: '',
      firstLast: '',
      adresaPrebivalista: '',
      entrepreneurName: '',
      nazivVrstaDjelatnosti: '',
      adresaDjelatnosti: '',
      showForm: true,
      vuIslands: false,
      from1: '',
      fromMenu1: false,
      from2: '',
      fromMenu2: false,
      from3: '',
      fromMenu3: false,
      to1: '',
      toMenu1: false,
      to2: '',
      toMenu2: false,
      to3: '',
      toMenu3: false,
      totalFromMenu: false,
      totalFrom: '',
      totalToMenu: false,
      totalTo: '',
      form: '',
      docType: { name: 'PDF', value: 'pdf' },
      ukupniPrimici: 0,
      primiciGotovina: 0,
      primiciBezgotovinski: 0,
      mjeseciSamostalni: 0,
      dohodakSamostalni: 0,
      mjeseciZajednicki: 0,
      dohodakZajednicki: 0,
      ukupniDohodak: 0,
      porezNaDohodak: 0,
      prirezPostotak: 0,
      prirezIznos: 0,
      ukupniPorezPrirez: 0,
      umanjenjePoreza: 0,
      ukupniPorezPrirezNakonUmanjenja: 0,
      uplaceniPorezPrirez: 0,
      razlikaUplataPovrat: 0,
      porezPrirezMjesecni: 0,
      taxPercent: 0.12,
      locationAddress: '',
      locationName: '',
      activityCode: '',
      currency: 'EUR',
      posdClasses: [],
      receipts: [],
      rules: {
        req: rules.req(),
        oib: rules.oib(),
        arrReq: rules.arrReq(),
        validPass: rules.validPass,
        money: rules.money()
      }
    }
  },
  mounted () {
    this.initializeDates()
    this.getPosdClasses()
  },
  watch: {
    search () {
      this.lastVisible = ''
    },
    totalFrom (newVal, oldVal) {
      // Samo pozovi ako su datumi već inicijalizirani (ne na prvi mount)
      if (oldVal !== '') {
        this.clearFormAndRefetch()
      }
    },
    totalTo (newVal, oldVal) {
      // Samo pozovi ako su datumi već inicijalizirani (ne na prvi mount)
      if (oldVal !== '') {
        this.clearFormAndRefetch()
      }
    }
  },
  computed: {
    radios () {
      return [
        { name: 'Da', value: true },
        { name: 'Ne', value: false }
      ]
    },
    formatFrom1 () {
      if (this.from1 !== '') {
        return new Intl.DateTimeFormat('hr-HR', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        }).format(new Date(this.from1))
      } else {
        return ''
      }
    },
    formatFrom2 () {
      if (this.from2 !== '') {
        return new Intl.DateTimeFormat('hr-HR', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        }).format(new Date(this.from2))
      } else {
        return ''
      }
    },
    formatFrom3 () {
      if (this.from3 !== '') {
        return new Intl.DateTimeFormat('hr-HR', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        }).format(new Date(this.from3))
      } else {
        return ''
      }
    },
    formatTo1 () {
      if (this.to1 !== '') {
        return new Intl.DateTimeFormat('hr-HR', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        }).format(new Date(this.to1))
      } else {
        return ''
      }
    },
    formatTo2 () {
      if (this.to2 !== '') {
        return new Intl.DateTimeFormat('hr-HR', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        }).format(new Date(this.to2))
      } else {
        return ''
      }
    },
    formatTo3 () {
      if (this.to3 !== '') {
        return new Intl.DateTimeFormat('hr-HR', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        }).format(new Date(this.to3))
      } else {
        return ''
      }
    },
    formatTotalFrom () {
      if (this.totalFrom !== '') {
        return new Intl.DateTimeFormat('hr-HR', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        }).format(new Date(this.totalFrom))
      } else {
        return ''
      }
    },
    formatTotalTo () {
      if (this.totalTo !== '') {
        return new Intl.DateTimeFormat('hr-HR', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        }).format(new Date(this.totalTo))
      } else {
        return ''
      }
    },

    totalFrom__datetime () {
      if (this.totalFrom !== '') {
        return parseInt(
          (new Date(`${this.totalFrom}`).getTime() / 1000).toFixed(0)
        )
      } else {
        return 0
      }
    },
    totalTo__datetime () {
      if (this.totalTo !== '') {
        return parseInt(
          (new Date(`${this.totalTo}T23:59:00`).getTime() / 1000).toFixed(0)
        )
      } else {
        return 0
      }
    },
    from1__datetime () {
      if (this.from1 !== '') {
        return parseInt(
          (new Date(`${this.from1}T00:00:00`).getTime() / 1000).toFixed(0)
        )
      } else {
        return 0
      }
    },
    from2__datetime () {
      if (this.from2 !== '') {
        return parseInt(
          (new Date(`${this.from2}T00:00:00`).getTime() / 1000).toFixed(0)
        )
      } else {
        return 0
      }
    },

    from3__datetime () {
      if (this.from3 !== '') {
        return parseInt(
          (new Date(`${this.from3}T00:00:00`).getTime() / 1000).toFixed(0)
        )
      } else {
        return 0
      }
    },
    to1__datetime () {
      if (this.to1 !== '') {
        return parseInt(
          (new Date(`${this.to1}T00:00:00`).getTime() / 1000).toFixed(0)
        )
      } else {
        return 0
      }
    },
    to2__datetime () {
      if (this.to2 !== '') {
        return parseInt(
          (new Date(`${this.to2}T00:00:00`).getTime() / 1000).toFixed(0)
        )
      } else {
        return 0
      }
    },

    to3__datetime () {
      if (this.to3 !== '') {
        return parseInt(
          (new Date(`${this.to3}T00:00:00`).getTime() / 1000).toFixed(0)
        )
      } else {
        return 0
      }
    }
  },
  methods: {
    initializeDates () {
      const now = new Date()
      const currentYear = now.getFullYear()
      const currentMonth = now.getMonth() // 0 = siječanj, 1 = veljača, ...

      if (currentMonth === 0) {
        // Siječanj - postavi datume na prošlu godinu (01.01. do 31.12.)
        const previousYear = currentYear - 1
        this.from1 = new Date(previousYear, 0, 1).toLocaleDateString('sv-SE').substr(0, 10)
        this.to1 = new Date(previousYear, 11, 31).toLocaleDateString('sv-SE').substr(0, 10)
        this.totalFrom = new Date(previousYear, 0, 1).toLocaleDateString('sv-SE').substr(0, 10)
        this.totalTo = new Date(previousYear, 11, 31).toLocaleDateString('sv-SE').substr(0, 10)
      } else {
        // Ostali mjeseci - postavi datume od 01.01. trenutne godine do danas
        this.from1 = new Date(currentYear, 0, 1).toLocaleDateString('sv-SE').substr(0, 10)
        this.to1 = now.toLocaleDateString('sv-SE').substr(0, 10)
        this.totalFrom = new Date(currentYear, 0, 1).toLocaleDateString('sv-SE').substr(0, 10)
        this.totalTo = now.toLocaleDateString('sv-SE').substr(0, 10)
      }
    },
    clearFormAndRefetch () {
      // Prikaži loading masku
      this.loading = true

      // Očisti sve kalkulirane vrijednosti
      this.receipts = []
      this.ukupniPrimici = 0
      this.primiciGotovina = 0
      this.primiciBezgotovinski = 0
      this.mjeseciSamostalni = 0
      this.dohodakSamostalni = 0
      this.mjeseciZajednicki = 0
      this.dohodakZajednicki = 0
      this.ukupniDohodak = 0
      this.porezNaDohodak = 0
      this.prirezPostotak = 0
      this.prirezIznos = 0
      this.ukupniPorezPrirez = 0
      this.umanjenjePoreza = 0
      this.ukupniPorezPrirezNakonUmanjenja = 0
      this.uplaceniPorezPrirez = 0
      this.razlikaUplataPovrat = 0
      this.porezPrirezMjesecni = 0

      // Ponovno dohvati podatke sa novim datumima
      this.getAll()
    },
    clearFrom2 () {
      this.from2 = ''
      this.changeMonths()
    },
    clearFrom3 () {
      this.from3 = ''
      this.changeMonths()
    },
    clearTo2 () {
      this.to2 = ''
      this.changeMonths()
    },
    clearTo3 () {
      this.to3 = ''
      this.changeMonths()
    },
    minto1 () {
      if (this.to1 !== '') {
        const following = new Date(`${this.to1}T00:00:00`)
        following.setUTCDate(following.getDate() + 1)
        return following.toISOString().substring(0, 10)
      } else {
        return '2023-01-01'
      }
    },
    minto2 () {
      if (this.to2 !== '') {
        const following = new Date(`${this.to2}T00:00:00`)
        following.setUTCDate(following.getDate() + 1)
        return following.toISOString().substring(0, 10)
      } else if (this.to1 !== '') {
        const following = new Date(`${this.to1}T00:00:00`)
        following.setUTCDate(following.getDate() + 1)
        return following.toISOString().substring(0, 10)
      } else {
        return '2023-01-01'
      }
    },
    minTo3 () {
      if (this.to3 !== '') {
        return this.toMenu3
      } else if (this.to2 !== '') {
        return this.to2
      } else if (this.to1 !== '') {
        return this.to1
      } else {
        return '2023-01-01'
      }
    },
    maxTo1 () {
      if (this.to1 !== '') {
        return this.to1
      } else {
        return '2030-12-31'
      }
    },
    maxTo2 () {
      if (this.to2 !== '') {
        return this.to2
      } else {
        return '2030-12-31'
      }
    },
    maxTo3 () {
      if (this.to3 !== '') {
        return this.to3
      } else {
        return '2030-12-31'
      }
    },
    checkTableValues (ukupniPrimici, ukupniMjeseci) {
      let returnVal = 0
      let payments = ukupniPrimici
      if (ukupniMjeseci !== 12) {
        payments = (ukupniPrimici / ukupniMjeseci) * 12
      }

      this.posdClasses.forEach((classes, i) => {
        if (payments >= classes.lower && payments <= classes.upper && i < 4) {
          returnVal = classes.total
          if (ukupniMjeseci !== 12) {
            returnVal = Math.round((returnVal / 12) * ukupniMjeseci)
          }
        }

        if (payments >= classes.lower && i === 4) {
          returnVal = classes.total
          if (ukupniMjeseci !== 12) {
            returnVal = Math.round((returnVal / 12) * ukupniMjeseci)
          }
        }
      })

      return returnVal
    },
    promjenaPrimitaka () {
      const that = this

      const primiciGotovina = parseFloat(
        (
          that.$refs.primiciGotovina.currencyToFloat(
            that.primiciGotovina
          ) * 100
        ).toFixed(2)
      )

      const primiciBezgotovinski = parseFloat(
        (
          that.$refs.primiciBezgotovinski.currencyToFloat(
            that.primiciBezgotovinski
          ) * 100
        ).toFixed(2)
      )

      that.ukupniPrimici = primiciGotovina + primiciBezgotovinski

      that.$refs.ukupniPrimici.$el.getElementsByTagName('input')[0].value =
        that.ukupniPrimici

      let totalMonths = 0
      if (that.from1 !== '' && that.to1 !== '') {
        const total = this.calculateMonths(that.from1, that.to1)
        totalMonths += total
      }
      if (that.from2 !== '' && that.to2 !== '') {
        const total = this.calculateMonths(that.from2, that.to2)
        totalMonths += total
      }
      if (that.from3 !== '' && that.to3 !== '') {
        const total = this.calculateMonths(that.from3, that.to3)
        totalMonths += total
      }

      that.mjeseciSamostalni = totalMonths

      that.$refs.mjeseciSamostalni.$el.getElementsByTagName('input')[0].value =
        that.mjeseciSamostalni

      that.dohodakSamostalni = this.checkTableValues(that.ukupniPrimici, totalMonths)

      that.$refs.dohodakSamostalni.$el.getElementsByTagName(
        'input'
      )[0].value = that.dohodakSamostalni

      const dohodakZajednicki = parseFloat(
        (
          this.$refs.dohodakZajednicki.currencyToFloat(that.dohodakZajednicki) *
          100
        ).toFixed(2)
      )

      that.ukupniDohodak = that.dohodakSamostalni + dohodakZajednicki

      that.$refs.ukupniDohodak.$el.getElementsByTagName(
        'input'
      )[0].value = that.ukupniDohodak

      that.porezNaDohodak = that.ukupniDohodak * this.taxPercent

      that.porezNaDohodak = Math.round(that.porezNaDohodak)

      that.$refs.porezNaDohodak.$el.getElementsByTagName('input')[0].value =
        parseInt(that.porezNaDohodak)

      that.ukupniPorezPrirez = that.porezNaDohodak

      that.ukupniPorezPrirezNakonUmanjenja = that.ukupniPorezPrirez
      that.$refs.ukupniPorezPrirezNakonUmanjenja.$el.getElementsByTagName(
        'input'
      )[0].value = that.ukupniPorezPrirezNakonUmanjenja

      that.razlikaUplataPovrat = that.ukupniPorezPrirez
      that.$refs.razlikaUplataPovrat.$el.getElementsByTagName(
        'input'
      )[0].value = that.razlikaUplataPovrat

      const ukupniDohodak = parseFloat(
        (
          this.$refs.ukupniDohodak.currencyToFloat(that.ukupniDohodak)
        ).toFixed(2)
      )

      var t = Math.round(ukupniDohodak * this.taxPercent)
      that.porezPrirezMjesecni = Math.round(t / that.mjeseciSamostalni)

      that.$refs.porezPrirezMjesecni.$el.getElementsByTagName(
        'input'
      )[0].value = that.porezPrirezMjesecni
    },
    promjenaZajednickogDohotka () {
      const that = this

      const dohodakSamostalni = parseFloat(
        (
          this.$refs.dohodakSamostalni.currencyToFloat(that.dohodakSamostalni) *
          100
        ).toFixed(2)
      )

      const dohodakZajednicki = parseFloat(
        (
          this.$refs.dohodakZajednicki.currencyToFloat(that.dohodakZajednicki) *
          100
        ).toFixed(2)
      )

      that.ukupniDohodak = dohodakSamostalni + dohodakZajednicki

      that.$refs.ukupniDohodak.$el.getElementsByTagName(
        'input'
      )[0].value = that.ukupniDohodak

      that.porezNaDohodak = that.ukupniDohodak * this.taxPercent

      that.porezNaDohodak = Math.round(that.porezNaDohodak)

      that.$refs.porezNaDohodak.$el.getElementsByTagName('input')[0].value =
        parseInt(that.porezNaDohodak)

      that.ukupniPorezPrirez = that.porezNaDohodak

      that.ukupniPorezPrirezNakonUmanjenja = that.ukupniPorezPrirez
      that.$refs.ukupniPorezPrirezNakonUmanjenja.$el.getElementsByTagName(
        'input'
      )[0].value = that.ukupniPorezPrirezNakonUmanjenja

      that.razlikaUplataPovrat = that.ukupniPorezPrirez
      that.$refs.razlikaUplataPovrat.$el.getElementsByTagName(
        'input'
      )[0].value = that.razlikaUplataPovrat

      const ukupniDohodak = parseFloat(
        (
          this.$refs.ukupniDohodak.currencyToFloat(that.ukupniDohodak)
        ).toFixed(2)
      )

      var t = Math.round(ukupniDohodak * this.taxPercent)
      that.porezPrirezMjesecni = Math.round(t / that.mjeseciSamostalni)

      that.$refs.porezPrirezMjesecni.$el.getElementsByTagName(
        'input'
      )[0].value = that.porezPrirezMjesecni
    },
    ukupniPorezPrirezPromjena () {
      const that = this
      const ukupniPorezPrirez = parseFloat(
        (
          this.$refs.ukupniPorezPrirez.currencyToFloat(
            this.ukupniPorezPrirez
          ) * 100
        ).toFixed(2)
      )

      that.ukupniPorezPrirezNakonUmanjenja = ukupniPorezPrirez
      that.$refs.ukupniPorezPrirezNakonUmanjenja.$el.getElementsByTagName(
        'input'
      )[0].value = that.ukupniPorezPrirezNakonUmanjenja

      that.razlikaUplataPovrat = that.ukupniPorezPrirez
      that.$refs.razlikaUplataPovrat.$el.getElementsByTagName(
        'input'
      )[0].value = that.razlikaUplataPovrat

      const ukupniDohodak = parseFloat(
        (
          this.$refs.ukupniDohodak.currencyToFloat(that.ukupniDohodak) *
          100
        ).toFixed(2)
      )

      var t = Math.round(ukupniDohodak * this.taxPercent)
      that.porezPrirezMjesecni = Math.round(t / that.mjeseciSamostalni)

      that.$refs.porezPrirezMjesecni.$el.getElementsByTagName('input')[0].value =
        that.porezPrirezMjesecni
    },
    promjenaPlacenog () {
      const ukupniPorezPrirezNakonUmanjenja = parseFloat(
        (
          this.$refs.ukupniPorezPrirezNakonUmanjenja.currencyToFloat(
            this.ukupniPorezPrirezNakonUmanjenja
          ) * 100
        ).toFixed(2)
      )

      const uplaceniPorezPrirez = parseFloat(
        (
          this.$refs.uplaceniPorezPrirez.currencyToFloat(this.uplaceniPorezPrirez) * 100
        ).toFixed(2)
      )

      this.razlikaUplataPovrat = ukupniPorezPrirezNakonUmanjenja - uplaceniPorezPrirez
      this.$refs.razlikaUplataPovrat.$el.getElementsByTagName(
        'input'
      )[0].value = this.razlikaUplataPovrat
    },
    umanjenjePorezaPromjena () {
      const ukupniPorezPrirez = parseFloat(
        (
          this.$refs.ukupniPorezPrirez.currencyToFloat(
            this.ukupniPorezPrirez
          ) * 100
        ).toFixed(2)
      )

      const umanjenjePoreza = parseFloat(
        (
          this.$refs.umanjenjePoreza.currencyToFloat(this.umanjenjePoreza) *
          100
        ).toFixed(2)
      )

      this.ukupniPorezPrirezNakonUmanjenja = ukupniPorezPrirez - umanjenjePoreza

      this.$refs.ukupniPorezPrirezNakonUmanjenja.$el.getElementsByTagName(
        'input'
      )[0].value = this.ukupniPorezPrirezNakonUmanjenja

      this.razlikaUplataPovrat = this.ukupniPorezPrirezNakonUmanjenja

      if (this.uplaceniPorezPrirez !== 0) {
        const uplaceniPorezPrirez = parseFloat(
          (
            this.$refs.uplaceniPorezPrirez.currencyToFloat(this.uplaceniPorezPrirez) * 100
          ).toFixed(2)
        )

        this.razlikaUplataPovrat =
          this.ukupniPorezPrirezNakonUmanjenja - uplaceniPorezPrirez
      }

      this.$refs.razlikaUplataPovrat.$el.getElementsByTagName(
        'input'
      )[0].value = this.razlikaUplataPovrat

      const ukupniDohodak = parseFloat(
        (
          this.$refs.ukupniDohodak.currencyToFloat(this.ukupniDohodak) *
          100
        ).toFixed(2)
      )

      var t = Math.round(ukupniDohodak * this.taxPercent)
      this.porezPrirezMjesecni = Math.round(t / this.mjeseciSamostalni)

      this.$refs.porezPrirezMjesecni.$el.getElementsByTagName('input')[0].value =
        this.porezPrirezMjesecni
    },

    calculateMonths (from, to) {
      const from1 = new Date(from)
      const to1 = new Date(to)

      let monthsDiff = (to1.getMonth() + 1) - (from1.getMonth() + 1)

      if (from1.getDate() === 1 && to1.getDate() >= 1) {
        monthsDiff += 1
      }

      return monthsDiff
    },
    changeMonths () {
      const that = this

      // Ažuriraj totalFrom i totalTo na osnovu from1 i to1
      // Ovo će triggerati watchers koji će ponovno dohvatiti podatke
      if (that.from1 !== '' && that.to1 !== '') {
        // Samo ako su se vrijednosti promijenile
        if (that.totalFrom !== that.from1 || that.totalTo !== that.to1) {
          that.totalFrom = that.from1
          that.totalTo = that.to1
          return // Watcher će pozvati clearFormAndRefetch koji će ponovno dohvatiti podatke
        }
      }

      let totalMonths = 0
      if (that.from1 !== '' && that.to1 !== '') {
        const total = this.calculateMonths(that.from1, that.to1)
        totalMonths += total
      }
      if (that.from2 !== '' && that.to2 !== '') {
        const total = this.calculateMonths(that.from2, that.to2)
        totalMonths += total
      }
      if (that.from3 !== '' && that.to3 !== '') {
        const total = this.calculateMonths(that.from3, that.to3)
        totalMonths += total
      }

      that.mjeseciSamostalni = totalMonths

      that.$refs.mjeseciSamostalni.$el.getElementsByTagName('input')[0].value =
        that.mjeseciSamostalni

      const primiciGotovina = parseFloat(
        (
          that.$refs.primiciGotovina.currencyToFloat(
            that.primiciGotovina
          ) * 100
        ).toFixed(2)
      )

      const primiciBezgotovinski = parseFloat(
        (
          that.$refs.primiciBezgotovinski.currencyToFloat(
            that.primiciBezgotovinski
          ) * 100
        ).toFixed(2)
      )

      that.ukupniPrimici = primiciGotovina + primiciBezgotovinski

      that.$refs.ukupniPrimici.$el.getElementsByTagName('input')[0].value =
        that.ukupniPrimici

      that.dohodakSamostalni = this.checkTableValues(that.ukupniPrimici, totalMonths)

      that.$refs.dohodakSamostalni.$el.getElementsByTagName(
        'input'
      )[0].value = that.dohodakSamostalni

      const dohodakZajednicki = parseFloat(
        (
          this.$refs.dohodakZajednicki.currencyToFloat(that.dohodakZajednicki) *
          100
        ).toFixed(2)
      )

      that.ukupniDohodak = that.dohodakSamostalni + dohodakZajednicki

      that.$refs.ukupniDohodak.$el.getElementsByTagName(
        'input'
      )[0].value = that.ukupniDohodak

      that.porezNaDohodak = that.ukupniDohodak * this.taxPercent

      that.porezNaDohodak = Math.round(that.porezNaDohodak)

      that.$refs.porezNaDohodak.$el.getElementsByTagName('input')[0].value =
        parseInt(that.porezNaDohodak)

      that.ukupniPorezPrirez = that.porezNaDohodak

      that.ukupniPorezPrirezNakonUmanjenja = that.ukupniPorezPrirez
      that.$refs.ukupniPorezPrirezNakonUmanjenja.$el.getElementsByTagName(
        'input'
      )[0].value = that.ukupniPorezPrirezNakonUmanjenja

      that.razlikaUplataPovrat = that.ukupniPorezPrirez
      that.$refs.razlikaUplataPovrat.$el.getElementsByTagName(
        'input'
      )[0].value = that.razlikaUplataPovrat

      const ukupniDohodak = parseFloat(
        (
          this.$refs.ukupniDohodak.currencyToFloat(that.ukupniDohodak)
        ).toFixed(2)
      )

      var t = Math.round(ukupniDohodak * this.taxPercent)
      this.porezPrirezMjesecni = Math.round(t / this.mjeseciSamostalni)

      that.$refs.porezPrirezMjesecni.$el.getElementsByTagName(
        'input'
      )[0].value = that.porezPrirezMjesecni
    },
    async getPosdClasses () {
      const classesConfig = await df.doc('project_constants/posd').get()
      if (!classesConfig?.data()) return

      if (classesConfig.data().classes) {
        this.posdClasses = classesConfig.data().classes
      }

      this.getAll()
    },
    async getAll () {
      const that = this
      try {
        let query = df
          .collection(`receipts/${state.getCurrentCompany().id}/receipts`)
          .orderBy('payment.date', 'desc')

        // 1631664000
        query = query
          .where('payment.current_status', 'in', ['PAID', 'REVERSED'])
          .where('payment.date', '>=', this.totalFrom__datetime)
          .where('payment.date', '<=', this.totalTo__datetime)

        let cashPay = 0
        let cashlessPay = 0

        query.get().then((snapshot) => {
          snapshot.forEach((doc) => {
            const receipt = doc.data()
            if (receipt.payment_method === 'NOVČANICE') {
              cashPay = cashPay + receipt.total
            } else {
              const tot = receipt.total

              // if (receipt.currency !== 'HRK' && receipt.payment.currency_rate !== -1 && receipt.payment.currency_rate !== 0) {
              //   var conversionRate = receipt.payment.currency_rate
              //   if (receipt.exchange_rate && receipt.exchange_rate.rate && receipt.exchange_rate.rate > 0 && receipt.exchange_rate.rate > receipt.payment.currency_rate) {
              //     conversionRate = receipt.exchange_rate.rate
              //   }

              //   const temp = (receipt.total.toFixed(2) / 100) * conversionRate
              //   tot = Math.round(temp * 100)
              // }

              cashlessPay += tot
            }

            this.receipts.push(receipt)
          })

          if (
            this.receipts[0] !== undefined &&
            this.receipts[0].company_details !== undefined
          ) {
            this.oib = this.receipts[0].company_details.oib
            this.adresaPrebivalista =
              this.receipts[0].company_details.address +
              ', ' +
              this.receipts[0].company_details.zip_code +
              ' ' +
              this.receipts[0].company_details.city +
              ', ' +
              this.receipts[0].company_details.country
          }

          that.primiciGotovina = cashPay
          that.primiciBezgotovinski = cashlessPay

          that.ukupniPrimici = that.primiciGotovina + that.primiciBezgotovinski

          that.$refs.primiciGotovina.$el.getElementsByTagName('input')[0].value =
            that.primiciGotovina

          that.$refs.primiciBezgotovinski.$el.getElementsByTagName(
            'input'
          )[0].value = that.primiciBezgotovinski

          that.$refs.ukupniPrimici.$el.getElementsByTagName('input')[0].value =
            that.ukupniPrimici

          let totalMonths = 0
          if (that.from1 !== '' && that.to1 !== '') {
            const total = this.calculateMonths(that.from1, that.to1)
            totalMonths += total
          }
          if (that.from2 !== '' && that.to2 !== '') {
            const total = this.calculateMonths(that.from2, that.to2)
            totalMonths += total
          }
          if (that.from3 !== '' && that.to3 !== '') {
            const total = this.calculateMonths(that.from3, that.to3)
            totalMonths += total
          }

          that.mjeseciSamostalni = totalMonths

          that.$refs.mjeseciSamostalni.$el.getElementsByTagName('input')[0].value =
            that.mjeseciSamostalni

          that.dohodakSamostalni = this.checkTableValues(that.ukupniPrimici, totalMonths)

          that.$refs.dohodakSamostalni.$el.getElementsByTagName(
            'input'
          )[0].value = that.dohodakSamostalni

          const dohodakZajednicki = parseFloat(
            (
              this.$refs.dohodakZajednicki.currencyToFloat(that.dohodakZajednicki) *
              100
            ).toFixed(2)
          )

          that.ukupniDohodak = that.dohodakSamostalni + dohodakZajednicki

          that.$refs.ukupniDohodak.$el.getElementsByTagName(
            'input'
          )[0].value = that.ukupniDohodak

          that.porezNaDohodak = that.ukupniDohodak * this.taxPercent

          that.porezNaDohodak = Math.round(that.porezNaDohodak)

          that.$refs.porezNaDohodak.$el.getElementsByTagName('input')[0].value =
            parseInt(that.porezNaDohodak)

          that.ukupniPorezPrirez = that.porezNaDohodak

          that.ukupniPorezPrirezNakonUmanjenja = that.ukupniPorezPrirez
          that.$refs.ukupniPorezPrirezNakonUmanjenja.$el.getElementsByTagName(
            'input'
          )[0].value = that.ukupniPorezPrirezNakonUmanjenja

          that.razlikaUplataPovrat = that.ukupniPorezPrirez
          that.$refs.razlikaUplataPovrat.$el.getElementsByTagName(
            'input'
          )[0].value = that.razlikaUplataPovrat

          const ukupniDohodak = parseFloat(
            (
              this.$refs.ukupniDohodak.currencyToFloat(that.ukupniDohodak)

            ).toFixed(2)
          )

          var t = Math.round(ukupniDohodak * this.taxPercent)

          this.porezPrirezMjesecni = Math.round(t / this.mjeseciSamostalni)

          that.$refs.porezPrirezMjesecni.$el.getElementsByTagName(
            'input'
          )[0].value = that.porezPrirezMjesecni

          // Sakrij loading masku nakon što su svi podaci učitani
          that.loading = false
        })
      } catch (error) {
        // Sakrij loading masku u slučaju greške
        this.loading = false
        this.showMsgBox({
          text: error || 'Internal error',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
        // console.error(error)
      }
    },
    async submit (documentType) {
      if (!this.$refs.generateReportForm.validate()) return

      // Postavi docType na osnovu kliknutog gumba
      this.docType = { name: documentType.toUpperCase(), value: documentType }

      this.showLoader()
      const cashPay = parseFloat(
        (
          this.$refs.primiciGotovina.currencyToFloat(this.primiciGotovina) * 100
        ).toFixed(2)
      )

      const cashlessPay = parseFloat(
        (
          this.$refs.primiciBezgotovinski.currencyToFloat(this.primiciBezgotovinski) *
          100
        ).toFixed(2)
      )

      const porezNaDohodak = parseFloat(
        (
          this.$refs.porezNaDohodak.currencyToFloat(this.porezNaDohodak) * 100
        ).toFixed(2)
      )

      const umanjenjePoreza = parseFloat(
        (
          this.$refs.umanjenjePoreza.currencyToFloat(
            this.umanjenjePoreza
          ) * 100
        ).toFixed(2)
      )

      const uplaceniPorezPrirez = parseFloat(
        (
          this.$refs.uplaceniPorezPrirez.currencyToFloat(this.uplaceniPorezPrirez) * 100
        ).toFixed(2)
      )

      const ukupniPorezPrirezNakonUmanjenja = parseFloat(
        (
          this.$refs.ukupniPorezPrirezNakonUmanjenja.currencyToFloat(this.ukupniPorezPrirezNakonUmanjenja) * 100
        ).toFixed(2)
      )

      const ukupniPorezPrirez = parseFloat(this.ukupniPorezPrirez)

      const ukupniPrimici = parseFloat(
        (
          this.$refs.ukupniPrimici.currencyToFloat(this.ukupniPrimici) * 100
        ).toFixed(2)
      )

      const dohodakSamostalni = parseFloat(
        (
          this.$refs.dohodakSamostalni.currencyToFloat(this.dohodakSamostalni) * 100
        ).toFixed(2)
      )

      const dohodakZajednicki = parseFloat(
        (
          this.$refs.dohodakZajednicki.currencyToFloat(this.dohodakZajednicki) * 100
        ).toFixed(2)
      )

      const ukupniDohodak = parseFloat(
        (
          this.$refs.ukupniDohodak.currencyToFloat(this.ukupniDohodak) * 100
        ).toFixed(2)
      )

      const porezPrirezMjesecni = parseFloat(
        (
          this.$refs.porezPrirezMjesecni.currencyToFloat(this.porezPrirezMjesecni) * 100
        ).toFixed(2)
      )

      const period = []

      period.push({ from: this.from1__datetime, to: this.to1__datetime })

      if (this.to2 !== '' && this.from2 !== '') {
        period.push({
          from: this.from2__datetime,
          to: this.to2__datetime
        })
      }

      if (this.to3 !== '' && this.from3 !== '') {
        period.push({
          from: this.from3__datetime,
          to: this.to3__datetime
        })
      }
      var documentApi = functions.httpsCallable('documentapi')

      try {
        const resp = await documentApi({
          action: {
            operation: 'get',
            entity: 'posd_form',
            params: {
              company_id: state.getCurrentCompany().id,
              date_from: this.totalFrom__datetime,
              date_to: this.totalTo__datetime,
              document_type: this.docType.value,
              name_of_activity: this.nazivVrstaDjelatnosti
                ? this.nazivVrstaDjelatnosti
                : '',
              entrepreneur_name: this.firstLast ? this.firstLast : '',
              residence_address: this.adresaPrebivalista
                ? this.adresaPrebivalista
                : '',
              entrepreneur_oib: this.oib ? this.oib : '',
              activity_address: this.adresaDjelatnosti
                ? this.adresaDjelatnosti
                : '',
              activity_period: period,
              cash_payments: cashPay || 0,
              cashless_payments: cashlessPay || 0,
              all_payments: ukupniPrimici,
              total_payments_solo: dohodakSamostalni,
              total_months_solo: this.mjeseciSamostalni,
              total_payments_together: dohodakZajednicki,
              total_months_together: parseInt(this.mjeseciZajednicki),
              total_income: ukupniDohodak,
              income_tax: porezNaDohodak || 0,
              super_tax_percent: 0,
              super_tax_amount: 0,
              income_tax_supertax: ukupniPorezPrirez,
              tax_reduction_vu_islands: umanjenjePoreza || 0,
              income_tax_supertax_reduction: ukupniPorezPrirezNakonUmanjenja,
              payed_lump_sum_tax: uplaceniPorezPrirez || 0,
              total_months: this.mjeseciSamostalni ? this.mjeseciSamostalni : 0,
              tax_supertax_monthly: porezPrirezMjesecni
            }
          }
        })
        if (resp.data) {
          if (!resp.data.document || resp.data.document === '') {
            this.hideLoader()
            this.error.message = resp.data.header.error
            this.showMsgBox({
              text: resp.data.header.error,
              actions: ['cancel'],
              cancelBtnText: this.$t('$vuetify.close'),
              color: 'error'
            })
          } else {
            let linkSource = ''
            let fileName = ''
            this.hideLoader()

            fileName = `report-posd.${new Date().getTime()}`
            if (this.docType.value === 'pdf') {
              linkSource = `data:application/pdf;base64,${resp.data.document
                }`
              fileName = `${fileName}.pdf`
            }

            if (this.docType.value === 'xlsx') {
              linkSource = `data:application/vnd.ms-excel;base64,${resp.data.document
                }`
              fileName = `${fileName}.xlsx`
            }

            const downloadLink = document.createElement('a')
            downloadLink.href = linkSource
            downloadLink.download = fileName
            downloadLink.click()
            this.$emit('onFinish')
          }
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.kpr-container {
  max-width: 860px;
  margin: 0 auto;
}

.kpr-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.07);
  padding: 28px 32px;
  margin-top: 24px;
}

.kpr-section-title {
  font-size: 12px;
  font-weight: 600;
  color: #64748B;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  border-bottom: 1px solid #EEF2F5;
  padding-bottom: 8px;
  margin-bottom: 16px;
  margin-top: 24px;
}

.kpr-section-title:first-child {
  margin-top: 0;
}

.kpr-field.v-text-field--outlined >>> fieldset {
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
}

.kpr-field.v-text-field--outlined:hover >>> fieldset {
  border-color: #B0BEC5 !important;
}

.kpr-field.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #00838F !important;
  border-width: 2px !important;
}

.kpr-field >>> .v-input__slot {
  background: #F8FAFC !important;
  min-height: 38px !important;
}

.kpr-field-disabled >>> .v-input__slot {
  background: #F1F5F9 !important;
}

.kpr-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #EEF2F5;
}

.kpr-generate-btn {
  background-color: #00BCD4 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  height: 42px !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
}

.kpr-generate-btn--excel {
  background-color: #217346 !important;
}

.posd-radio-label {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
